import toast, { Toaster } from "react-hot-toast";


const COLORS = {
  blue: "#0096C7",
  errorRed: "#EF4444",
  cardBg: "#FBFBFB",
  white: "#FFFFFF",
};

export const showToast = ({ type = "success", message }) => {
  if (type === "success") {
    toast.success(message, {
      style: {
        border: `1px solid ${COLORS.blue}`,
        padding: "16px",
        color: COLORS.blue,
        background: COLORS.cardBg,
        borderRadius: "8px",
        fontWeight: 500,
      },
      iconTheme: {
        primary: COLORS.blue,
        secondary: COLORS.white,
      },
    });
  }

  if (type === "error") {
    toast.error(message, {
      style: {
        border: `1px solid ${COLORS.errorRed}`,
        padding: "16px",
        color: COLORS.errorRed,
        background: COLORS.cardBg,
        borderRadius: "8px",
        fontWeight: 500,
      },
      iconTheme: {
        primary: COLORS.errorRed,
        secondary: COLORS.white,
      },
    });
  }
};

const CustomToast = ({ position = "bottom-left" }) => {
  return <Toaster position={position} reverseOrder={false} />;
};

export default CustomToast;